import React, { useState } from 'react';
import {UploadFile} from "antd/es/upload/interface";
import {FileUploader} from "../../../../../core/file-uploader/file-uploader";
import {Property, PropertyFile, PropertyFileType} from "../../../../../../models/property/property";
import {createFileList} from "./file_list.factory";
import {propertyService} from "../../../../../../services/property/property.service";
import {useRequiredStore} from "../../../../../../utils/store";
import {RootStoreContext} from "../../../../../../stores/root/root.store";

export interface ClaimPartsImagesProps {
    property: Property;
    files: PropertyFile[];
    disableUpload?: boolean;
    type: PropertyFileType;
}

export const ReviewListPropertyImages: React.FC<ClaimPartsImagesProps> = ({property, files, disableUpload, type}) => {

    const {authStore: { generateUri }} = useRequiredStore(RootStoreContext);
    const [fileList, setFileList] = useState<UploadFile<any>[]>(() => createFileList(files, generateUri));

    return (
        <FileUploader
            fileList={fileList}
            onFileListChanged={fileList => setFileList(fileList)}
            upload={file => propertyService.uploadFile(file, property.id, type)}
            onRemove={file => propertyService.removeFile(parseInt(file.uid))}
            disableUpload={disableUpload}
        />
    )
};